angular.module("ainapp")
    .controller("addPostingTemplatesController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Posting Templates";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Currencys = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencys = response.data;
            })

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.PostingTemplatesById(data).then(function (response) {
                    if (response.data) {
                        $scope.addData = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.InsertRow = function () {

                var detail = {

                    Debit: 0,
                    Credit: 0,
                    AccountMasterId: "",
                }

                $scope.addData.PostingTemplateDetails.push(detail);
            }

            $scope.Init = function () {


                $scope.ViewVal = 0;
                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.addData = {
                    Date: new Date(),
                    Name: "",
                    Remarks: "",
                    CurrencyId: "",
                    PostingTemplateDetails: [],
                }

                for (var i = 0; i < 5; i++) {
                    $scope.InsertRow(1);
                }


                $scope.ErrorText = "";
                $scope.Load = false;

                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                })

                if ($stateParams.VoucherId > 0) {
                    $scope.loadVoucher($stateParams.VoucherId);
                }


            }
            $scope.Init();

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Journal Voucher";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountMasterId = data.Id;
                    $scope.SelectedCE.AccountMaster = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountMasterId = data.Id;
                    $scope.SelectedCE.AccountMaster = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                var a = $scope.addData.PostingTemplateDetails.indexOf(data);

                if (($scope.addData.PostingTemplateDetails.length - 1) == a) {
                    $scope.InsertRow(1);
                }

            }


            $scope.SaveVocuher = function () {

                var totcredit = 0;
                var totdebit = 0;
                angular.forEach($scope.addData.PostingTemplateDetails, function (e) {
                    if (e.AccountMasterId > 0) {
                        totdebit = totdebit + e.Debit;
                        totcredit = totcredit + e.Credit;
                    }
                })

                if ($scope.addData.Name == "") {
                    toastr.warning("Enter Name");
                } else if ($scope.addData.PostingTemplateDetails.length == 0) {
                    toastr.warning("Invalid Details");
                } else if (totdebit != totcredit) {
                    toastr.warning("Total Debit Not Matching With Total Credit");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.AddPostingTemplate($scope.addData).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            $scope.Load = false;
                            toastr.warning("Failed");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }


            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    if ($scope.addData.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }

            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeletePostingTemplate($scope.addData.Id).then(function (response) {
                        if (response.data) {
                            toastr.success("Deleted");
                            $('#deleteModal').modal('hide');
                            $state.go("postingTemplates");
                        } else {
                            toastr.warning("Failed");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                    })
            }


            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.deleteRow = function () {
                var index = $scope.addData.PostingTemplateDetails.indexOf($scope.ClickedRow);
                $scope.addData.PostingTemplateDetails.splice(index, 1);
            }


                }])
